import { sendGet, sendPost, sendPostForExport } from 'helpers/axios';

export const apiGetListReferralBonus = (params) => sendGet(`/api/reward/list-reward`, params);
export const apiConfirmReferralBonus = (params) => sendPost(`/api/reward/confirm`, params);
export const apiExportReferralBonus = (params) => sendPostForExport(`api/reward/export`, params);
